<template>
  <Menu></Menu>
  <div id="box">
    <div v-if="loading" class="loadingSpinner"><span class="spinner-border"></span></div>
    <!-- =========================================================================================================== -->
    <div class="container mb-2">
      <div class="row p-0">
        <div class="col p-0 text-center">
          <h5 class="fw-bold d-inline-block bi-person-fill-gear">&nbsp; Manage Users</h5>
        </div>
        <div class="col-auto p-0 text-center">
          <button class="btn btn-dark w-100 bi-arrow-clockwise" @click="reloadData()" :disabled="loading">&nbsp; Reload</button>
        </div>
      </div>
      <!-- ----------------------------------------------- -->
      <div class="row p-0">
        <div class="col p-0">
          <hr>
        </div>
      </div>
      <!-- ----------------------------------------------- -->
          
      <div class="row p-0">

        <div class="col p-0">
          <form autocomplete="off">
          <div class="input-group w-100">
            <span class="input-group-text bi-search"></span>
              <input class="form-control" autocomplete="chrome-off" name="filter" type="text" placeholder="Search by name" v-model.trim='filter'>
            </div>
          </form>
        </div>
        
        <div class="col p-0">
        </div>
        <div class="col-auto p-0">
        </div>
        
        <div class="col p-0">
          <button v-if="$store.getters.access('user_add')" class="btn btn-success w-100" @click="showAddUser()" :disabled="loading">
            <span class="bi-plus-circle">&nbsp; Add User</span>
          </button>
        </div>


      </div>
    </div>
    <!-- =========================================================================================================== -->
    <table class="table table-sm table-bordered table-striped table-hover table-fixed">
      <!-- ----------------------------------------------- -->
      <thead>
        <tr class="table-dark">
          <th>Name</th>
          <th class="w-20">Username</th>
          <th class="w-20">Type</th>
          <th class="w-20">Last Login</th>
          <th class="text-center w-50px"><span class="bi-gear"></span></th>
        </tr>
      </thead>
      <!-- ----------------------------------------------- -->
      <tbody style="height: calc(100vh - 190px)">        
        <tr v-for="user in users_filtered" :key="user._id" v-bind:class="user.enabled ? '' : 'table-danger'">
          <td>{{ user.name }}</td>
          <td class="w-20">{{ user.username }}</td>
          <td class="w-20">{{ user.type }}</td>
          <td class="w-20">{{ user.last_login }}</td>
          <td class="dropstart text-center w-50px">
            <a data-bs-toggle='dropdown' class="btn btn-sm btn-secondary p-1"><span class="bi-three-dots-vertical"></span></a>
            <ul class="dropdown-menu">
              <div v-if="$store.getters.isSuper || !['admin', 'advanced user'].includes(user.type)">
                <li v-if="$store.getters.access('user_logout')"><a class="dropdown-item bi-box-arrow-left" @click="logoutUser(user._id)">Logout</a></li>

                <div v-if="$store.getters.access('user_edit')">
                  <li v-if="user.enabled"><a class="dropdown-item bi-lock-fill" @click="disableUser(user._id)">Disable</a></li>
                  <li v-else><a class="dropdown-item bi-unlock-fill" @click="enableUser(user._id)">Enable</a></li>
                </div>
              </div>

              <li v-if="
                $store.getters.access('user_edit') && 
                ($store.getters.isSuper || user.type == 'user' || $store.state.id == user._id)
              "><a class="dropdown-item bi-pencil-fill" @click="showEditUser(user)">Edit</a></li>
              
              <div v-if="$store.getters.isSuper || !['admin', 'advanced user'].includes(user.type)">
                <li v-if="$store.getters.access('user_del')"><a class="dropdown-item bi-trash" @click="delUser(user)">Delete</a></li>
                <li v-if="$store.getters.access('user_priv')"><a class="dropdown-item bi-key-fill" @click="privilege(user)">Privilege</a></li>
              </div>
              <li v-if="$store.getters.access('user_log')"><a class="dropdown-item bi-clock-history" @click="logs(user)">Log</a></li>
            </ul>
          </td>
        </tr>
      </tbody>
      <!-- ----------------------------------------------- -->
    </table>
    <!-- =========================================================================================================== -->
    <div id="addUserModal" ref="addUserModal" class="modal fade">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <!-- ----------------------------------------------- -->
          <div class="modal-header">
            <h5 class="modal-title">Add New User</h5>
            <a class="btn-close" data-bs-dismiss='modal'></a>
          </div>
          <!-- ----------------------------------------------- -->
          <div class="modal-body">
            <div class="input-group w-100 mb-2">
              <span class="input-group-text w-25">Name</span>
              <input class="form-control" type="text" v-model.trim="newUser.name">
            </div>
            <div class="input-group w-100 mb-2">
              <span class="input-group-text w-25">Username</span>
              <input class="form-control" type="text" v-model.trim="newUser.username">
            </div>
            <div class="input-group w-100 mb-2">
              <span class="input-group-text w-25">Password</span>
              <input class="form-control" type="password" v-model.trim="newUser.password">
            </div>
          </div>
          <!-- ----------------------------------------------- -->
          <div class="modal-footer">
            <div class="container">
              <div class="row">
                <div class="col">
                  <a class="btn btn-secondary w-100" data-bs-dismiss='modal'>Cancel</a>
                </div>
                <div class="col">
                  <a class="btn btn-success w-100" @click="addUser()">
                    <span v-if="loading" class="spinner-border"></span>
                    <span>Add</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <!-- ----------------------------------------------- -->
        </div>
      </div>
    </div>
    <!-- =========================================================================================================== -->
    <div id="editUserModal" ref="editUserModal" class="modal fade">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <!-- ----------------------------------------------- -->
          <div class="modal-header">
            <h5 class="modal-title">Edit User: {{ editUser.nameOriginal }}</h5>
            <a class="btn-close" data-bs-dismiss='modal'></a>
          </div>
          <!-- ----------------------------------------------- -->
          <div class="modal-body">
            <div class="input-group w-100 mb-2">
              <span class="input-group-text w-25">Name</span>
              <input class="form-control" type="text" v-model.trim="editUser.name">
            </div>
            <div class="input-group w-100 mb-2">
              <span class="input-group-text w-25">Username</span>
              <input class="form-control" type="text" v-model.trim="editUser.username">
            </div>
            <div class="input-group w-100 mb-2">
              <span class="input-group-text w-25">Password</span>
              <input class="form-control" type="password" v-model.trim="editUser.password">
            </div>
          </div>
          <!-- ----------------------------------------------- -->
          <div class="modal-footer">
            <div class="container">
              <div class="row">
                <div class="col">
                  <a class="btn btn-secondary w-100" data-bs-dismiss='modal'>Cancel</a>
                </div>
                <div class="col">
                  <a class="btn btn-success w-100" @click="saveUser()">
                    <span v-if="loading" class="spinner-border"></span>
                    <span>Save</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <!-- ----------------------------------------------- -->
        </div>
      </div>
    </div>
  </div>

</template>
<!-- ******************************************************** -->
<script>
  const $ = require('jquery');
  export default {
    name: 'UsersPage',
    data(){
      return {
        loading: false,
        users: [],
        filter: '',
        newUser:{
          name: '',
          username: '',
          password: '',
        },
        editUser:{
          id: '',
          nameOriginal: '',
          name: '',
          username: '',
          password: '',
        },
      }
    },
    created() {
      this.reloadData();
    },
    mounted(){
    },
    //**********************************************************
    computed:{
      users_filtered(){
        let filter = this.filter.toLowerCase();
        return this.users.filter((x)=>x.name.toLowerCase().includes(filter));
      }
    },
    //**********************************************************
    methods:{
      //**********************************************************
      async reloadData(){
        this.loading = true;
        this.users = [];
        var ack = await this.$service.getUsers();
        if(ack.state != 'OK'){
          this.$toast(ack.state);
        }
        else{
          this.users = ack.data;
        }
        this.loading = false;
      },
      //**********************************************************
      async showAddUser(){
        $('#addUserModal').modal('show');
      },
      //**********************************************************
      async addUser(){
        this.loading = true;
        await this._addUser();
        this.loading = false;
      },
      //**********************************************************
      async _addUser(){
        if(!this.newUser.name || !this.newUser.username || !this.newUser.password){
          return this.$toast('Some Fields are empty', 'warning');
        }
        var ack = await this.$service.addUser({
          name: this.newUser.name,
          username: this.newUser.username,
          password: this.newUser.password,
        });
        if(ack.state != 'OK') return this.$toast(ack.state);
        $('#addUserModal').modal('hide');
        this.$toast('User Added Successfuly', 'success');
        this.reloadData();
      },
      //**********************************************************
      async showEditUser(user){
        this.editUser.id = user._id;
        this.editUser.nameOriginal = user.name;
        this.editUser.name = user.name;
        this.editUser.username = user.username;
        this.editUser.password = '';
        $('#editUserModal').modal('show');
      },
      //**********************************************************
      async saveUser(){
        this.loading = true;
        await this._saveUser();
        this.loading = false;
      },
      //**********************************************************
      async _saveUser(){
        if(!this.editUser.name || !this.editUser.username){
          return this.$toast('Some Fields are empty', 'warning');
        }
        var ack = await this.$service.editUser({
          id: this.editUser.id,
          name: this.editUser.name,
          username: this.editUser.username,
          password: this.editUser.password,
        });
        if(ack.state != 'OK') return this.$toast(ack.state);
        $('#editUserModal').modal('hide');
        this.$toast('User Saved Successfuly', 'success');
        this.reloadData();
      },
      //**********************************************************
      async delUser(user){
        var reply = await this.$swal.fire({
          title: "Confirm Delete",
          html: `Are you sure you want to delete the user <b>${user.name}</b>`,
          icon: "error", showCancelButton: true, focusCancel: true,
          confirmButtonText: "Confirm Delete", confirmButtonColor: "#d33", 
        });
        if(!reply.isConfirmed) return;
        this.loading = true;
        var ack = await this.$service.delUser({ id: user._id });
        if(ack.state != 'OK'){
          this.$toast(ack.state);
        }
        else{
          this.$toast('User Deleted Successfuly', 'success');
          this.reloadData();
        }
        this.loading = false;
      },
      //**********************************************************
      async logoutUser(user_id){
        var ack = await this.$service.logoutUser({ id: user_id });
        if(ack.state != 'OK') return this.$toast(ack.state);
        this.$toast('User Logged out Successfuly', 'success');
        this.reloadData();
      },
      //**********************************************************
      async enableUser(user_id){
        var ack = await this.$service.enableUser({ id: user_id });
        if(ack.state != 'OK') return this.$toast(ack.state);
        this.$toast('User Enabled Successfuly', 'success');
        this.reloadData();
      },
      //**********************************************************
      async disableUser(user_id){
        var ack = await this.$service.disableUser({ id: user_id });
        if(ack.state != 'OK') return this.$toast(ack.state);
        this.$toast('User disabled Successfuly', 'success');
        this.reloadData();
      },
      //**********************************************************
      async privilege(user){
        this.$router.push({
            name: 'Privilege',
            params: { id: user._id }
        })
      },
      //**********************************************************
      async logs(user){
        this.$router.push({
            name: 'Logs',
            params: { id: user._id }
        })
      },
      //**********************************************************
      //**********************************************************
      //**********************************************************
      //**********************************************************
      //**********************************************************
    }
  }
</script>
<!-- ******************************************************** -->
<style scoped>
</style>
  